import type { ComponentPropsWithoutRef } from 'react'

export type ScrollRegionAxis = 'y' | 'x' | 'both'

export type ScrollRegionClassOptions = {
  axis?: ScrollRegionAxis
  /** 仅用于内嵌输入框等微滚动区；页面/面板级列表勿隐藏滚动条 */
  hideScrollbar?: boolean
}

/**
 * 全站纵向/横向滚动区类名：须与 `index.css` 中 `.scroll-region` 搭配使用。
 * 页面级列表、Modal 正文、登录卡内滚动等均应使用本函数或 {@link ScrollRegion}。
 */
export function scrollRegionClass(
  axis: ScrollRegionAxis = 'y',
  opts?: Pick<ScrollRegionClassOptions, 'hideScrollbar'>,
): string {
  const parts = ['scroll-region', 'min-h-0']
  if (axis === 'y' || axis === 'both') {
    parts.push('overflow-y-auto', 'overscroll-y-contain')
  }
  if (axis === 'x' || axis === 'both') {
    parts.push('overflow-x-auto', 'overscroll-x-contain')
  }
  if (opts?.hideScrollbar) parts.push('glyphicai-scrollbar-none')
  return parts.join(' ')
}

export type ScrollRegionProps = ComponentPropsWithoutRef<'div'> & ScrollRegionClassOptions

/** 带主题滚动条样式的可滚动容器（类名见 {@link scrollRegionClass}） */
export function ScrollRegion({
  axis = 'y',
  hideScrollbar,
  className,
  ...rest
}: ScrollRegionProps) {
  return (
    <div
      className={[scrollRegionClass(axis, { hideScrollbar }), className].filter(Boolean).join(' ')}
      {...rest}
    />
  )
}
